import React from "react";
import CountUp from "react-countup";

const BydAttohomeimage = () => {
  return (
    <section className="fluid bg-light-gray-1">
      <div id="atto-banner">
        <div className="box-container ">
          <div className="seal-box  ">
            <div className="box-content">
              <div className="box-countup ">
                <div className="subContent "></div>₹ {""}
                <CountUp
                  start={0}
                  end={24.99}
                  duration={3}
                  decimals={2}
                  redraw={true}
                />{" "}
                Lakh
              </div>
              <div className="subContent ">Starting Price* (Ex-Showroom)</div>
            </div>
          </div>
          <div className="seal-box ">
            <div className="box-content">
              <div className="box-countup ">
                <div className="subContent"></div>
                e-Platform{" "}
                <CountUp
                  start={0}
                  end={3}
                  duration={3}
                  decimals={1}
                  redraw={true}
                />
              </div>
              <div className="subContent">The Born EV e-Platform 3.0</div>
            </div>
          </div>
          <div className="seal-box ">
            <div className="">
              <div className="box-countup ">
                <CountUp
                  start={0}
                  end={7.3}
                  duration={5}
                  decimals={1}
                  redraw={true}
                />
                s
              </div>
              <div className="subContent">0 - 100 km/h*</div>
            </div>
          </div>
          <div className="seal-box ">
            <div className="box-content">
              <div className="box-countup ">
                <CountUp
                  start={0}
                  end={521}
                  duration={3}
                  decimals={0}
                  redraw={true}
                />{" "}
                km
              </div>
              <div className="subContent">Top Driving range*(ARAI tested)</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BydAttohomeimage;
